/**
 * Normalize multiplex inventory Excel / API screen rows for admin tables.
 * Column order matches inventory template: Sr_No … Discounted_MRP.
 */
export function mapMultiplexDocToGridRows(doc) {
  if (!doc) return [];
  const list = Array.isArray(doc.screens)
    ? doc.screens
    : Array.isArray(doc)
      ? doc
      : [];
  return list.map((s, idx) => ({
    id: s._id?.toString?.() || `row-${idx}-${s.screenCode || ""}`,
    srNo: s.srNo ?? idx + 1,
    state: s.state || "",
    city: s.city || "",
    cinemaCategory: s.cinemaCategory || "",
    cinema: s.cinema || "",
    audiNum: s.audiNum ?? "",
    seatingCapacity: s.seatingCapacity ?? "",
    screenCode: s.screenCode || "",
    casCodes: s.casCodes ?? s.CASCodes ?? "",
    uploadCodes: s.uploadCodes ?? s.UploadCodes ?? "",
    audiForm: s.audiForm || "",
    PricePerUnit: s.PricePerUnit ?? 0,
    DiscountedPrice: s.DiscountedPrice ?? 0,
  }));
}
